<style lang="less">
    iframe {
        width: 100%;
        height: 100%;
        min-height: 100%;
    }
    .iframe-contain {
        height: 100%;
        width: 100%;
    }
</style>
<style lang="less">
.iframe-modal {
  .ivu-modal-close {
    top: -30px;
    right: 0px;
    background: rgba(1,1,1,0.6);
  }
  .ivu-modal-header {
    height: 0px !important;
    padding: 0px !important;
  }
      .ivu-modal-body {
          max-height: 1000px !important;
          padding: 0px;
      }
      .ivu-modal-footer {
        padding: 0px;
      }
 }

</style>
<template>
  <div
    class="iframe-contain"
  >
    <div
      ref="iframe-contain"
    />
  </div>
</template>
<script :route="{path: '/dashBoard/routerDetail/:id',noChkout: true}">
  import PowerBIUtil from './../../libs/powerbi_util'
  // const workspace_id = 'f673ae1c-be02-4e79-8dc3-91f423ed6e51';
  // const report_id = '10a767d5-32b6-40ff-885c-c67b7e592339';
  const SIZE_CHANGE_TIMER = Symbol('sizeChangeTimer')
  const changeSizeFun = function() {
    const _this = this
    _this[SIZE_CHANGE_TIMER] = setTimeout(function() {
      _this.setContainHeight()
      _this[SIZE_CHANGE_TIMER] = null
    }, 500)
  }
  // ./../../../static/video/6839126731877808522.MP4
  export default {
    /* router_info_start */
    router_info: {
      path: '/dashBoard/routerDetail/:id',
      noChkout: true,
    },
    /* router_info_end */
    data() {
      this.resize_call = null
      this.timer = null
      return {
        showModal:false,
        modalObj:{
          width:0,
          height: 0,
        },
        video: require('./../../../static/video/6839126731877808522.MP4')
      }
    },
    mounted() {
      // eslint-disable-next-line
            // let timer = null
      let workspace_id = null
      let report_id = null
      const vuex_state = this.$store.state
      const _this = this
      const { params = {} } = this.$router.currentRoute || {}
      const timer_fun = (vuex_state, _this, params) => {
        if (!Object.keys(vuex_state.menu_id_hash).length) {
          _this.timer = setTimeout(() => {
            timer_fun(vuex_state, _this, params)
          }, 300)
        } else {
          clearTimeout(_this.timer)
          if (vuex_state.menu_id_hash[params.id] === undefined) {
            _this.$router.push('/dashBoard/routerDetail')
            return
          }
          const {pb_report_id, pb_workspace_id} = vuex_state.menu_id_hash[params.id]
          workspace_id = pb_workspace_id
          report_id = pb_report_id
          _this.timer = null
          PowerBIUtil.embed(_this.$refs['iframe-contain'], workspace_id, report_id);
        }
      }
      timer_fun(vuex_state, _this, params)
      this.grand = this.$router.afterEach((to) => {
        const { params } = to
        if (to.fullPath.includes('/dashBoard/routerDetail')) {
          timer_fun(vuex_state, _this, params)
        }
      })
      this.setContainHeight()
      _this.resize_call = () => {
        if (_this[SIZE_CHANGE_TIMER]) {
          clearTimeout(_this[SIZE_CHANGE_TIMER])
        }
        changeSizeFun.apply(_this)
      }
      window.addEventListener("resize", _this.resize_call);
    },
    beforeDestroy() {
      const _this = this
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.grand) {
        this.grand()
      }
      window.removeEventListener('resize', _this.resize_call)
    },
    methods: {
      setContainHeight() {
        const height = (document.documentElement.clientHeight || document.body.clientHeight)
        this.$refs['iframe-contain'].style.height = height - 135 + 'px'
      }
    }
  }
</script>
